module.exports = __webpack_public_path__ + "media/images/top/place/place1-edab9989acba9e822b72a2c4c1cb330c.png";